<template>
  <div>
    <div class="page-content">
      <div class="container">
        <form-wizard
          @on-complete="onSubmit"
          title="Add New Device"
          subtitle=""
          color="#269af1"
          >
            <tab-content title="Customer details" icon="fa fa-user" :before-change="beforeDeviceDetails">
            <b-card   class="section-container">
              <b-form-group id="CustomerDetails" label="Customer Details:" label-for="CustomerDetails">
              <autocomplete
                :suggestions="getUsers"
                placeholder="Search..."
                :keys="searchKey"
                :display="displayKey"
                :onSelected="onSelected"
                :value="selectedName"
                v-model="selection">
                </autocomplete>
              </b-form-group>
                <b-card
                  v-show="currentUser !== null"
                  :title="(currentUser !== null) ? currentUser.first_name + ' ' + currentUser.last_name: ''"
                  tag="article"
                  style="width: 100%; border-radius: 12px; text-align: center;"
                  id="profile_id">
                  <div class="card-text profile">
                    <p>{{(currentUser !== null) ? currentUser.phone : '' }}</p>
                    <p>{{(currentUser !== null) ? currentUser.email : '' }}</p>
                  </div>
                </b-card>
              </b-card>
            </tab-content>
            <tab-content title="Device Details" icon="fa fa-server">
              <b-card  class="section-container">
                  <b-form-group id="DeviceIDGroup" label="Device ID:" label-for="DeviceID">
                    <b-form-input id="DeviceID" type="text" v-model="deviceParam.inverter_number" required placeholder="Enter Device ID">
                    </b-form-input>
                  </b-form-group>
                  <div  class="row">
                      <div class="form-group col-md-12">
                        <label class="col-form-label pt0">State</label>
                        <b-form-select v-model="deviceParam.state_id" :options="stateOptions" @change="fetchLgas" class="mb-3">
                        </b-form-select>
                      </div>
                  </div>
                  <div  class="row">
                      <div class="form-group col-md-12">
                        <label class="col-form-label pt0">Local Govt. Area</label>
                        <b-form-select v-model="deviceParam.lga_id" :options="lgaOptions" class="mb-3">
                        </b-form-select>
                      </div>
                  </div>
                  <b-form-group id="DeviceCapacityGroup" label="Device Capacity (Watts):" label-for="deviceCapacity">
                    <b-form-input id="deviceCapacity" type="text" v-model="deviceParam.inverter_capacity" required placeholder="Enter Device Capacity">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="NumberOfPanel" label="Number Of Panel:" label-for="NumberOfPanel">
                    <b-form-input id="NumberOfPanel" type="text" v-model="deviceParam.number_of_panels" required placeholder="Number Of Panel">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="PanelRating" label="Panel Rating:" label-for="PanelRating">
                    <b-form-input id="PanelRating" type="text" v-model="deviceParam.panel_rating" required placeholder="Panel Rating">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="NumberOfBatteries" label="Number Of Batteries:" label-for="NumberOfBatteries">
                    <b-form-input id="NumberOfBatteries" type="text" v-model="deviceParam.number_of_batteries" required placeholder="Number Of Batteries">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="BatteryRating" label="Battery Rating:" label-for="BatteryRating">
                    <b-form-input id="BatteryRating" type="text" v-model="deviceParam.battery_rating" required placeholder="Battery Rating">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="DeviceTypeGroup" label="Device Type:" label-for="deviceType">
                    <b-form-select id="deviceType" :options="systemTypeOptions" required v-model="deviceParam.system_type_id">
                    </b-form-select>
                  </b-form-group>
              </b-card>
            </tab-content>
        </form-wizard>

      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import Autocomplete from '../../utils/Autocomplete';
  import { mapGetters } from 'vuex'
  export default {
    components:{
      Autocomplete
    },
    data() {
      return {
        searchKey: ['first_name','last_name'],
        displayKey: ['first_name','last_name'],
        currentUser: null,
        selectedName: '',
        selection: '',
        form: {
          email: '',
          name: '',
          food: null,
          checked: [],
        },
        deviceParam:{
          battery_rating:	null,
          inverter_capacity:	null,
          inverter_number:	null,
          kit_capacity:	null,
          lga_id:	null,
          number_of_batteries:	null,
          number_of_panels:	null,
          panel_rating:	null,
          state_id:	null,
          system_type_id:	null,
          user_id:	null
        },
        foods: [{
            text: 'Select One',
            value: null,
          },
          'Monthly', 'Outright', 'Lease2Own',
        ],
        type: [{
            text: 'Select One',
            value: null,
          },
          'Arnergy 300', 'Arnergy 1000', 'Arnergy 2000', 'Arnergy 5000',
        ],
        show: true,
        selectedState: null,
        selectedLga: null,
        stateOptions: [
          { value: null, disabled: true, text: "Please select a state" }
        ],
        lgaOptions: [{ value: null, disabled: true, text: "Please select LGA" }],
        systemTypeOptions: [{ value: null, disabled: true, text: "Please select a system type" }],
        }
    },
    computed: {
      ...mapGetters([
        'getUserById',
        'getDeviceById',
        'getUsers',
        'getDummy',
        'getDevices'
      ])
    },
    methods: {
      onSubmit() {
        this.deviceParam.kit_capacity = this.deviceParam.inverter_capacity;
        // console.log(JSON.stringify(this.deviceParam));
          const HTTP = this.$httpUtils.instance;
          const url = "/devices";
          const container = this;
          HTTP.post(url, this.deviceParam)
            .then(response => {
              // console.log(response.data.data.);
              container.$router.push({path: `/device/${response.data.data.inverter_number}`});
            })
            .catch(error => {
              console.log("error", error);
            });
      },
      onSelected(obj){
        this.currentUser = obj;
        this.deviceParam.user_id = obj.id;
        this.selectedName = this.currentUser.full_name+ ' '+ this.currentUser.last_name;
        // console.log(JSON.stringify(obj));
      },
      onReset(evt) {
        evt.preventDefault();
        /* Reset our form values */
        this.form.email = '';
        this.form.name = '';
        this.form.food = null;
        this.form.checked = [];
        /* Trick to reset/clear native browser form validation state */
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      },
      beforeDeviceDetails(){
        if(this.deviceParam.user_id === null){
          alert("Please select a user.")
          return false;
        } else {
          return true;
        }
      },
      fetchStates() {
          const HTTP = this.$httpUtils.instance;
          const url = "/states";
          HTTP.get(url)
            .then(response => {
              const statesList = response.data;
              let str = JSON.stringify(statesList);
              str = str.replace(/id/g, "value");
              str = str.replace(/name/g, "text");
              const tempState = JSON.parse(str);
              tempState.unshift({
                value: null,
                disabled: true,
                text: "Please select a state"
              });
              this.stateOptions = tempState;
            })
            .catch(error => {
              console.log("error", error);
            });
        },
      fetchSysTypes() {
          const HTTP = this.$httpUtils.instance;
          const url = "/system-types";
          HTTP.get(url)
            .then(response => {

              const systemTypes = response.data;
              systemTypes.filter(x => {
                x.value = x.id;
                x.text = x.name;
              });

              systemTypes.unshift({
                value: null,
                disabled: true,
                text: "Please select a system type"
              });
              this.systemTypeOptions = systemTypes;
            })
            .catch(error => {
              console.log("error", error);
            });
        },
        fetchLgas(state) {
          if (state !== null) {
            const context = this;
            const HTTP = this.$httpUtils.instance;
            const url = `/states/${state}/lga`;
            HTTP.get(url)
              .then(response => {
                const statesList = response.data;
                let str = JSON.stringify(statesList);
                str = str.replace(/id/g, "value");
                str = str.replace(/name/g, "text");
                const tempLga = JSON.parse(str);
                tempLga.unshift({
                  value: null,
                  disabled: true,
                  text: "Please select LGA"
                });
                context.lgaOptions = tempLga;
              })
              .catch(error => {
                console.log("error", error);
              });
          }
        }
    },
    mounted() {
      this.fetchStates();
      this.fetchSysTypes();
    }
  }

</script>
<style>
.section-container{
border-radius: 7px;
background: #fff;
-webkit-box-shadow: 0 4px 70px -18px rgba(0,0,0,.2);
box-shadow: 0 4px 70px -18px rgba(0,0,0,.2);
margin-bottom: 1.875rem;
max-width: 600px;
margin-left: auto;
margin-right: auto;
min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/New.vue